/* ============================================================================
 * SYLONI® · Ripple Reveal (Sprint 4 / Batch 1)
 *
 * 全站点击触发金/白色涟漪扩散。
 *
 * Application:
 *   - All <button> elements (auto)
 *   - [data-syloni-ripple] explicit opt-in
 *   - .ripple-host class (preview compat)
 *   - Opt-out: [data-syloni-no-ripple]
 *
 * Per-element configuration (optional):
 *   - data-ripple-color="gold" | "white" (default auto-detect)
 *
 * Auto-disabled on:
 *   - prefers-reduced-motion: reduce
 *
 * Last update: 2026-04-27 · Batch 1 v0.4.0
 * ============================================================================ */

(function () {
  'use strict';

  const HOST_SELECTOR =
    'button, a[data-syloni-ripple], [data-syloni-ripple], .ripple-host';
  const OPT_OUT = '[data-syloni-no-ripple]';
  const ANIMATION_MS = 950;

  function shouldSkip() {
    return (
      document.documentElement.classList.contains('syloni-no-motion') ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  // Heuristic: dark background → gold ripple, else white
  function pickColor(host) {
    const explicit = host.dataset.rippleColor;
    if (explicit === 'gold' || explicit === 'white') return explicit;
    const bg = window.getComputedStyle(host).backgroundColor;
    const m = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!m) return 'gold';
    const [r, g, b] = [parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10)];
    // Perceived brightness
    const lum = 0.299 * r + 0.587 * g + 0.114 * b;
    return lum < 80 ? 'gold' : 'white';
  }

  function spawn(host, x, y) {
    if (!host || shouldSkip()) return;
    if (host.matches(OPT_OUT)) return;

    const ripple = document.createElement('span');
    ripple.className = 'syloni-ripple syloni-ripple--' + pickColor(host);
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';

    // Ensure host can contain the ripple
    const cs = window.getComputedStyle(host);
    if (cs.position === 'static') host.style.position = 'relative';
    if (cs.overflow !== 'hidden') host.style.overflow = 'hidden';

    host.appendChild(ripple);
    setTimeout(() => {
      if (ripple.parentNode) ripple.remove();
    }, ANIMATION_MS);
  }

  document.addEventListener(
    'click',
    (e) => {
      const host = e.target.closest(HOST_SELECTOR);
      if (!host) return;
      const r = host.getBoundingClientRect();
      spawn(host, e.clientX - r.left, e.clientY - r.top);
    },
    { passive: true, capture: false }
  );

  // Touch devices: spawn on touchstart for instant feedback
  document.addEventListener(
    'touchstart',
    (e) => {
      const host = e.target.closest(HOST_SELECTOR);
      if (!host) return;
      const t = e.touches[0];
      const r = host.getBoundingClientRect();
      spawn(host, t.clientX - r.left, t.clientY - r.top);
    },
    { passive: true }
  );

  if (window.SYLONI) {
    window.SYLONI.modules.ripple = {
      version: '0.4.0',
      spawn,
      pickColor,
    };
  }

  console.log(
    '%c SYLONI ripple v0.4.0 ',
    'background:#D4AF37;color:#0A0A0A;padding:3px 8px;font-family:monospace;letter-spacing:2px;font-weight:600;'
  );
})();
